import { DictionaryObject, useFetch } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useAuditReportStates() {
  return useFetch<DictionaryObject[]>(
    `${EvidenceApiUrl.AUDIT_REPORT}/states/list`,
    {
      method: 'GET',
      cacheResponse: true,
    }
  );
}
